module.exports = __webpack_public_path__ + "img/image31.7f0f101d.png";